import React from 'react';
import './Navbar.css'; // Import your CSS file for styling
import { useNavigate } from 'react-router-dom';

function Navbar() {
    const navigate = useNavigate(); // ✅ REQUIRED

    // ✅ Function to close the dropdown menu
    const closeDropdown = () => {
        const dropdownMenu = document.querySelector('.dropdown-menu');
        const dropdownToggle = document.querySelector('.dropdown-toggle');
        
        if (dropdownMenu) {
            dropdownMenu.classList.remove('show');
        }
        if (dropdownToggle) {
            dropdownToggle.setAttribute('aria-expanded', 'false');
        }
    };

    // ✅ Function to close mobile navbar
    const closeMobileMenu = () => {
        const navbarCollapse = document.getElementById('navbarSupportedContent');
        if (navbarCollapse && navbarCollapse.classList.contains('show')) {
            navbarCollapse.classList.remove('show');
        }
    };

    // ✅ Combined function to handle navigation
    const handleNavigation = (path) => {
        closeDropdown();
        closeMobileMenu();
        navigate(path);
    };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <button 
        className="navbar-toggler" 
        type="button" 
        data-toggle="collapse" 
        data-target="#navbarSupportedContent" 
        aria-controls="navbarSupportedContent" 
        aria-expanded="false" 
        aria-label="Toggle navigation"
      >
        <span className="navbar-toggler-icon"></span>
      </button>

      <div className="collapse navbar-collapse" id="navbarSupportedContent">
        <ul className="navbar-nav mr-auto">
          <li className="nav-item active">
            <a className="nav-link" href="/">Home</a>
          </li>
          <li className="nav-item active">
            <a className="nav-link" href="/#About"  onClick={(e) => {
              e.preventDefault();
              closeMobileMenu();
              if (window.location.pathname !== '/') {
                navigate('/#About');
              } else {
                document.getElementById('About')?.scrollIntoView({ behavior: 'smooth' });
              }
            }}>About us</a>
          </li>
          <li className="nav-item active">
            <a className="nav-link" href="/#contact"  onClick={(e) => {
              e.preventDefault();
              closeMobileMenu();
              document
                .getElementById('contact')
                ?.scrollIntoView({ behavior: 'smooth' });
            }}>Contact us</a>
          </li>
          
          <li className="nav-item dropdown">
            <button 
              className="nav-link dropdown-toggle btn btn-link" 
              id="navbarDropdown" 
              data-toggle="dropdown" 
              aria-haspopup="true" 
              aria-expanded="false"
            >
              Who's Who
            </button>
            <div className="dropdown-menu" aria-labelledby="navbarDropdown">
              <button className="dropdown-item" onClick={() => handleNavigation('/whoswho#blocksocialaudit')}>Block Social Auditor</button>
              <button className="dropdown-item" onClick={() => handleNavigation('/whoswho#vrp')}>Village Resource Person</button>
              <div className="dropdown-divider"></div>
              <button className="dropdown-item" onClick={() => handleNavigation('/whoswho#other')}>Other</button>
            </div>
          </li>
          <li className="nav-item active">
            <a className="nav-link" href="/dashboard">Login</a>
          </li>
        </ul>
      </div>
    </nav>
  );
}

export default Navbar;